import { gql } from "graphql-request";

/** Inscripción pública EIDU: reutiliza crearDocente (sin login). */
export const inscribirEidu = gql`
  mutation crearDocente(
    $tipo: Int
    $identificacion: String
    $nombre: String
    $correoInstitucional: String
    $telefono: String
    $unidad: String
    $carrera: String
    $periodoMatricula: Int
    $grupo: Int
    $universidad: String
    $pais: String
    $tieneDiscapacidad: Boolean
    $tipoDiscapacidad: String
    $requiereApoyo: Boolean
    $detalleApoyo: String
  ) {
    crearDocente(
      tipo: $tipo
      identificacion: $identificacion
      nombre: $nombre
      correoInstitucional: $correoInstitucional
      telefono: $telefono
      unidad: $unidad
      carrera: $carrera
      periodoMatricula: $periodoMatricula
      grupo: $grupo
      sede: false
      universidad: $universidad
      pais: $pais
      tieneDiscapacidad: $tieneDiscapacidad
      tipoDiscapacidad: $tipoDiscapacidad
      requiereApoyo: $requiereApoyo
      detalleApoyo: $detalleApoyo
    ) {
      docente {
        id
        identificacion
        nombre
      }
      matriculado {
        id
      }
      success
    }
  }
`;
